import { Grid } from '@mui/material'
import ReplayIcon from '@mui/icons-material/Replay';
import { IWalletLoanCard } from './IWalletLoanCard';

const WalletLoanCard = ({ amount, date, title, color }: IWalletLoanCard) => {
    return (
        <Grid
            xs={12}
            sx={{
                background: 'transparent',
                height: '125px',
                display: 'flex',
                alignItems: 'center',
                width: "100%"
            }}
        >
            <div
                className='carousel-cards px-5 rounded-sm flex flex-col justify-center gap-4 py-3 w-full relative'
                style={{
                    borderRadius: '5px',
                    height: '100%',
                    background: `${color}`

                }}>


                <div className='text-white flex justify-between items-center z-10'>
                    <div className='text-white flex items-center text-[.8rem]'>
                        {title}
                    </div>
                    {date && <div className='text-[.8rem]'> {date}</div>}

                </div>
                <div className='text-white flex justify-between items-center z-10'>
                    <div> <span className='font-bold tracking-wider'>{amount.toLocaleString('fa-IR')}</span > <span className='text-[.8rem]'>ریال</span></div>

                    {date && <div>
                        <span style={{ fontSize: "0.8rem", color: "#fff", paddingTop: "5px" }}>تاریخ انقضا </span>
                    </div>}

                </div>
            </div>
        </Grid>
    )
}

export default WalletLoanCard